@defer (when claim) {
    <div class="container mt-4">
        <div class="row justify-content-center">
            <div class="col-12 w-100">
                <div class="heading-lg text-center">{{ claim?.policyType }}</div>
                <div class="heading-md text-center mb-3">{{ claim?.coverageType }} Claim</div>
                <div class="heading-sm mb-4 text-center">To be completed by the employer</div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-12 col-md-6">
                <div class="card">
                    <!-- Using a custom class instead of overriding padding -->
                    <div class="card-body">
                        <form [formGroup]="claimForm">
                            <div class="row mb-4">
                                <div class="col-12">
                                    <div class="caption">
                                        Claim number:&nbsp;
                                        <span class="caption-lg">{{ claim?.claimReferenceNumber }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="heading-sm mb-4">I hereby certify to A.W.G. Dewar, Inc. that:</div>
                                </div>
                            </div>
                            <fieldset formGroupName="employerParent">
                                <div class="row">
                                    <div class="col-12 col-xl-6">
                                        <div class="form-group mb-4">
                                            <label for="firstName" class="form-label">Employee first name</label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="firstName"
                                                formControlName="firstName"
                                                appShowFieldErrors="Employee first name"
                                                maxlength="50" />
                                        </div>
                                    </div>
                                    <div class="col-12 col-xl-6">
                                        <div class="form-group mb-4">
                                            <label for="lastName" class="form-label">Employee last name</label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="lastName"
                                                formControlName="lastName"
                                                appShowFieldErrors="Employee last name"
                                                maxlength="50" />
                                        </div>
                                    </div>
                                </div>
                            </fieldset>

                            <div class="row">
                                <div class="col-12">
                                    <div class="caption mb-3">
                                        Complete only if employee was RELOCATED/CHANGED EMPLOYMENT which results in relocation to another geographic locale.
                                    </div>
                                </div>
                            </div>
                            <div class="row align-items-top">
                                <div class="col-12 col-xl-6">
                                    <div class="form-group mb-4">
                                        <label for="employerRelocationTransferDate" class="form-label">Employee transfer date</label>
                                        <div class="input-group mb-3">
                                            <input
                                                class="form-control"
                                                id="employerRelocationTransferDate"
                                                formControlName="employerRelocationTransferDate"
                                                placeholder="mm/dd/yyyy"
                                                name="employerRelocationTransferDate"
                                                ngbDatepicker
                                                appDateMask
                                                [minDate]="minValidDate"
                                                [maxDate]="maxValidDate"
                                                firstDayOfWeek="7"
                                                #employerRelocationTransferDate="ngbDatepicker"
                                                appShowFieldErrors="Employee transfer date" />

                                            <button class="btn btn-input-group" type="button" (click)="employerRelocationTransferDate.toggle()">
                                                <i class="bi bi-calendar3"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <app-address
                                [addressFormGroup]="claimForm.get('employeeNewAddress')"
                                [addressLabel]="'Address of the employee’s new job location'"
                                [showAddress2]="showEmployeeNewAddress2"
                                (toggleAddress2)="toggleEmployeeNewAddress2()"
                                [states]="states"
                                [countries]="countries"></app-address>

                            <div class="row mb-4 mt-4">
                                <div class="col-12">
                                    <div class="section-heading">Employer Information</div>
                                </div>
                            </div>
                            <fieldset formGroupName="employer">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group mb-4 position-relative">
                                            <label for="organizationName" class="form-label">Company name</label>
                                            <textarea
                                                type="text"
                                                id="organizationName"
                                                class="form-control"
                                                formControlName="organizationName"
                                                appShowFieldErrors="Company name"
                                                maxlength="255"
                                                (input)="updateCharacterCount($event, 'organizationName')"></textarea>
                                            <div class="text-small form-text text-end char-count">{{ characterCounts.organizationName }}/255 characters</div>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>

                            <app-address
                                [addressFormGroup]="claimForm.get('employer.address')"
                                [addressLabel]="''"
                                [showAddress2]="showEmployerAddress2"
                                (toggleAddress2)="toggleEmployerAddress2()"
                                [states]="states"
                                [countries]="countries"></app-address>

                            <div class="row">
                                <div class="col-12">
                                    <div class="caption mb-3">{{ employerCertificationText }}</div>
                                </div>
                            </div>

                            <!--                             <div class="row mb-4 mt-4">
                                <div class="col-12">
                                    <div class="section-heading">Physician Information</div>
                                </div>
                            </div>
 -->
                            <fieldset>
                                <div class="row">
                                    <div class="col-12 col-xl-6">
                                        <div class="form-group mb-4">
                                            <label for="employerCertifyingOfficialName" class="form-label">Name of company official</label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="employerCertifyingOfficialName"
                                                formControlName="employerCertifyingOfficialName"
                                                appShowFieldErrors="Company official"
                                                maxlength="255" />
                                        </div>
                                    </div>
                                    <div class="col-12 col-xl-6">
                                        <div class="form-group mb-4">
                                            <label for="employerCertifyingOfficialTitle" class="form-label">Title</label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="employerCertifyingOfficialTitle"
                                                formControlName="employerCertifyingOfficialTitle"
                                                appShowFieldErrors="Title"
                                                maxlength="100" />
                                        </div>
                                    </div>
                                </div>
                            </fieldset>

                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group mb-4 position-relative">
                                        <label for="employerCertifyingOfficialContact" class="form-label">Telephone number / email address of company official:</label>
                                        <textarea
                                            type="text"
                                            id="employerCertifyingOfficialContact"
                                            class="form-control"
                                            formControlName="employerCertifyingOfficialContact"
                                            appShowFieldErrors="Telephone number / email address of company official"
                                            maxlength="255"
                                            (input)="updateCharacterCount($event, 'employerCertifyingOfficialContact')"></textarea>
                                        <div class="col-12 col-lg-12 d-flex justify-content-between">
                                            <div class="form-text email-address">(For claim verification purposes only)</div>
                                            <div class="text-small form-text text-end char-count">{{ characterCounts.employerCertifyingOfficialContact }}/255 characters</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group mb-4">
                                        <label for="employerSignature" class="form-label">Signature</label>
                                        <app-signature-pad formControlName="employerSignature" appShowFieldErrors="Signature"></app-signature-pad>
                                        <div class="text-small form-text mt-2">{{ signatureText }}</div>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div class="row">
                            <div class="col-12 text-center">
                                <button class="btn btn-link" (click)="fraudNotice()">Important fraud information regarding your claim</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="caption mt-3" [innerHTML]="instructionText"></div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 text-center">
                                <button
                                    class="btn btn-primary me-3 mt-5 mb-5"
                                    (click)="onSubmit()"
                                    (keydown.enter)="onSubmit()"
                                    [disabled]="isSaving"
                                    [class.btn--waiting]="isSaving">
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Fraud Notices Modal Template -->
} @placeholder {
    <div class="container mt-4">
        <div class="row text-center">
            <div class="col-12 heading-md pb-2">Loading Claim...</div>
        </div>
    </div>
}
